import type { PostTypeFields } from '@tribeplatform/gql-client/graphql'
import type {
  PostType,
  MutationArchivePostTypeArgs,
} from '@tribeplatform/gql-client/types'

import {
  useMutation,
  UseMutationOptions,
} from '../../lib/react-query/useMutation.js'
import { useQueryClient } from '../../lib/react-query/useQueryClient.js'
import { useTribeClient } from '../../useTribeClient.js'
import { getNetworkKey } from '../../utils/keys/network.key.js'
import { getPostTypesKey, getPostTypeKey } from '../../utils/keys/post.key.js'

export const useArchivePostType = (options?: {
  fields?: PostTypeFields
  useMutationOptions?: UseMutationOptions<
    PostType,
    Error,
    MutationArchivePostTypeArgs
  >
}) => {
  const { useMutationOptions, fields = 'basic' } = options || {}
  const { client } = useTribeClient()
  const queryClient = useQueryClient()
  const postTypesKey = getPostTypesKey()
  const networkKey = getNetworkKey()

  return useMutation<PostType, Error, MutationArchivePostTypeArgs>(
    input => client.postType.archive(input, fields),
    {
      onSettled: variables => {
        const postTypeKey = getPostTypeKey({ variables: { id: variables?.id } })

        queryClient.invalidateQueries(postTypesKey)
        queryClient.invalidateQueries(postTypeKey)
        queryClient.invalidateQueries(networkKey)
      },
      ...useMutationOptions,
    },
  )
}
